<div class="dialog-shell">
	<div class="dialog-header">
		<div>
			<h2 class="fw-bold fs-xs">Resumo do lote</h2>
			<p class="fs-xxs gray">
				Revise quantos beneficiários serão alterados antes de aplicar no
				plataforma.
			</p>
		</div>
		<button mat-icon-button type="button" (click)="onCancel()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="total-card">
		<span class="count">{{ data.total }}</span>
		<span class="label">itens preparados para aplicação</span>
	</div>

	<div class="summary-list">
		<div class="summary-card">
			<strong>{{ data.autoSuggestedCount }}</strong>
			<span>Sugestões automáticas</span>
		</div>
		<div class="summary-card">
			<strong>{{ data.manualReviewedCount }}</strong>
			<span>Revisados manualmente</span>
		</div>
	</div>

	<div class="summary-list">
		<div
			class="summary-card"
			*ngFor="let summary of data.summaries; trackBy: trackByAction"
		>
			<strong>{{ summary.count }}</strong>
			<span>{{ summary.label }}</span>
		</div>
	</div>

	<div class="dialog-actions">
		<button mat-stroked-button type="button" (click)="onCancel()">
			Voltar
		</button>
		<button mat-flat-button color="primary" type="button" (click)="onConfirm()">
			Aplicar alterações
		</button>
	</div>
</div>
